import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { UserProfileService } from './user-profile.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService implements OnDestroy {
  private socket: WebSocket;
  private reconnectInterval: number = 1000;
  public isConnected: boolean = false;
  public messageSubject: Subject<any> = new Subject<any>();
  public lastNotification: any; // Variable para almacenar la última notificación
  private webSocketUrl: string; // Variable para almacenar la URL completa del WebSocket
  userInfo: UserInfo;

  constructor(private _profile: UserProfileService) {
    this.getUserInfo(); // Obtener información del usuario al iniciar el servicio
  }

  private connect() {
    if (!this.webSocketUrl) {
      return;
    }

    this.socket = new WebSocket(this.webSocketUrl);


    this.socket.onopen = () => {
      this.isConnected = true;
    };
    this.socket.onmessage = (event) => {
      const message = JSON.parse(event.data);

      if (message.notification) {
        // Comprobar que title y description están presentes
        const { title, description } = message.notification;

        if (title && description) {
          this.lastNotification = message.notification;
        } else {
          console.warn('Notification object is missing title or description:', message.notification);
        }
      } else {
        console.warn('Received message does not contain a notification:', message);
      }

      this.messageSubject.next(message);
    };
    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    this.socket.onclose = () => {
      this.isConnected = false;
      this.reconnect();
    };
  }

  private reconnect() {
    setTimeout(() => {
      this.connect(); // Llamar a connect sin pasar la URL, ya que ahora la URL es parte del estado de la clase
    }, this.reconnectInterval);
  }

  sendMessage(message: any) {
    if (this.isConnected) {
      this.socket.send(JSON.stringify(message));
    } else {
      console.error('WebSocket is not open. Message not sent:', message);
    }
  }

  ngOnDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  }

  getUserInfo() {
    this._profile.getUserProfileInformation().subscribe(
      (data: any) => {
        this.userInfo = data.response;

        // Solo después de que se haya obtenido userInfo, crea y guarda la URL completa
        this.webSocketUrl = `wss://microservice.binar10.co/ws/notification/?role_id=${this.userInfo.roles[0].id}`;
        this.connect(); // Establece la conexión WebSocket con la URL correcta
      },
      (error) => {
        // this._swal.errorHandler(error);
      }
    );
  }
}


interface UserInfo {
  id: number;
  name: string;
  last_name: string;
  cell_phone: string;
  dni: string;
  email: string;
  roles: any;
}
